import { z } from "zod";
import { ItemMarginSchema, ItemYieldSchema } from "./items";

/** Schema for an item default values record stored per organization. */
export const ItemDefaultValuesSchema = z.object({
  id: z.string(),
  organizationId: z.string(),
  margin: z.array(ItemMarginSchema),
  yield: z.array(ItemYieldSchema),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type ItemDefaultValues = z.infer<typeof ItemDefaultValuesSchema>;

/** Params for creating or updating item default values. */
export const UpsertItemDefaultValuesParamsSchema = z.object({
  margin: z.array(ItemMarginSchema).optional(),
  yield: z.array(ItemYieldSchema).optional(),
});
export type UpsertItemDefaultValuesParams = z.infer<
  typeof UpsertItemDefaultValuesParamsSchema
>;

/** API response for GET /item-default-values. */
export const GetItemDefaultValuesResponseSchema = z.object({
  itemDefaultValues: ItemDefaultValuesSchema.nullable(),
});
export type GetItemDefaultValuesResponse = z.infer<
  typeof GetItemDefaultValuesResponseSchema
>;

/** API response for PUT /item-default-values. */
export const UpsertItemDefaultValuesResponseSchema = z.object({
  itemDefaultValues: ItemDefaultValuesSchema,
});
export type UpsertItemDefaultValuesResponse = z.infer<
  typeof UpsertItemDefaultValuesResponseSchema
>;

/** API response for DELETE /item-default-values. */
export const DeleteItemDefaultValuesResponseSchema = z.object({
  success: z.literal(true),
});
export type DeleteItemDefaultValuesResponse = z.infer<
  typeof DeleteItemDefaultValuesResponseSchema
>;
